import React, { useState } from 'react';
import {
    AppBar,
    Toolbar,
    Typography,
    Button,
    Box,
    IconButton,
    Container,
    Drawer,
    List,
    ListItem,
    ListItemText,
} from '@mui/material';
import { Link, useLocation } from 'react-router-dom';
import { Menu as MenuIcon, Search } from '@mui/icons-material';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import CloseIcon from '@mui/icons-material/Close';

export default function Header() {
    const [drawerOpen, setDrawerOpen] = useState(false);
    const location = useLocation();

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    const toggleDrawer = (open) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }
        setDrawerOpen(open);
    };

    const isActive = (path) => (location.pathname === path ? 'active' : '');

    const navLinks = [
        { label: 'Home', path: '/' },
        { label: 'Browse Medications', path: '/medicines' },
        { label: 'Contact Congressman', path: '/contact-congressman' },
        { label: 'Newsroom', path: '/healthcare' },
        { label: 'Contact', path: '/contact' },
    ];

    const renderMenuItems = () => (
        <>
            {navLinks.map((link) => {
                const isHash = link.path.includes('#');
                return (
                    <Button
                        key={link.path}
                        color="inherit"
                        component={Link}
                        to={link.path}
                        onClick={(e) => {
                            if (isHash && location.pathname === '/') {
                                const element = document.getElementById(link.path.split('#')[1]);
                                if (element) element.scrollIntoView({ behavior: 'smooth' });
                            }
                        }}
                        className={isActive(link.path)}
                        sx={{ textTransform: 'none', fontSize: '14px', fontWeight: 500 }}
                    >
                        {link.label}
                    </Button>
                );
            })}

			{/* Donate Button is now part of navLinks */}
        </>
    );

    const renderMobileMenu = () => (
        <Drawer anchor="right" open={drawerOpen} onClose={toggleDrawer(false)} className='header_drawer'>
            <IconButton onClick={() => setDrawerOpen(false)} className='cross'>
                <CloseIcon />
            </IconButton>
            <List className='drawer_menu'>
                {navLinks.map((link) => {
                    const isHash = link.path.includes('#');
                    return (
                        <ListItem 
                            key={link.path} 
                            button 
                            component={Link} 
                            to={link.path}
                            onClick={(e) => {
                                toggleDrawer(false)(e);
                                if (isHash && location.pathname === '/') {
                                    setTimeout(() => {
                                        const element = document.getElementById(link.path.split('#')[1]);
                                        if (element) element.scrollIntoView({ behavior: 'smooth' });
                                    }, 100);
                                }
                            }}
                        >
                            <ListItemText primary={link.label} />
                        </ListItem>
                    );
                })}

            </List>
        </Drawer>
    );

    return (
        <>
            <AppBar color="inherit">
                <Container>
                    <Toolbar className="header_flex">
                        <Typography
                            className="brand_logo"
                            variant="h6"
                            component={Link}
                            to="/"
                            style={{ textDecoration: 'none', color: 'inherit', flexGrow: isMobile ? 1 : 0 }}
                        >
                            <img src="/RX-Pose.svg" alt="logo" />
                        </Typography>
                        {isMobile ? (
                            <>
                                <IconButton onClick={toggleDrawer(true)}>
                                    <MenuIcon />
                                </IconButton>
                                {renderMobileMenu()}
                            </>
                        ) : (
                            <>
                                <Box className="header_menu" sx={{ flexGrow: 1, display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: '4px' }}>
                                    {renderMenuItems()}
                                </Box>
                                {/* <IconButton sx={{ ml: 1 }}>
                                    <Search />
                                </IconButton> */}
                            </>
                        )}
                    </Toolbar>
                </Container>
            </AppBar>
        </>
    );
}
